//--------------------------------------Graph config object functions--------------------------//

import {
  isEmptyObj,
  getMin,
  getMax,
  getPluckedData,
  getFilteredData,
  getAverageData,
  getExtremeData,
  debounce,
  getElementContentWidth,
  getMinMaxRange
} from "./common";

import { getAlarms, getAlerts } from "./alarm";

export const plotOptions = {
  flags: {
    allowOverlapX: true,
    y: -13
  },
  series: {
    animation: false,
    turboThreshold: 9999
  }
};
export const labels = {
  format: "{value:%m/%d/%Y<br>%H:%M:%S}",
  rotation: 0,
  align: "center",
  x: 11,
  y: 60,
  style: {
    textOverflow: "none"
  }
};
export const labelsMob = {
  format: "{value:%m/%d/%Y<br>%H:%M:%S}",
  rotation: -45,
  align: "center",
  x: -15,
  y: 45
};
export const getData = self => {
  console.log("GetData", self);
};
let bucketExtremePoints = [];
export const emptyObj = () => {
  return {};
};
export const gridLineWidth = 1;
export const notificationCountFunc = (chartSize, alarmSize) =>
  parseInt(chartSize / alarmSize);

export const bucketsFunc = (start, end, count) =>
  Array.from(
    {
      length: count
    },
    (v, k) => {
      const InitialArrMinCounter = k ? k : 1;
      const min =
        parseInt(start + ((end - start) / count) * k) + InitialArrMinCounter;
      const max = start + ((end - start) / count) * (k + 1);
      return { min, max };
    }
  );

export const getbatchCount = (arr, key) => {
  return arr.reduce(function (previousValue, currentObject) {
    return previousValue + (currentObject[key] ? 1 : 0);
  }, 0);
};

export const groupedBucketDataFunc = (dataPoints, buckets) => {
  let groupedAlarmBucket = [];
  buckets.forEach((bucket, idx) => {
    let arr = dataPoints.reduce((groupedAlarms, datapoint) => {
      if (
        datapoint.capturedTime >= bucket.min &&
        datapoint.capturedTime <= bucket.max
      ) {
        groupedAlarms.push(datapoint);
      }
      return groupedAlarms;
    }, []);
    if (arr.length) {
      let batchCount = getbatchCount(arr, "alarmTriggered");
      let avgCapturedTime =
        batchCount > 1
          ? getMin(getPluckedData(arr, "capturedTime")) +
          (getMax(getPluckedData(arr, "capturedTime")) -
            getMin(getPluckedData(arr, "capturedTime"))) /
          2
          : batchCount === 1
            ? getFilteredData(arr, "alarmTriggered")[0].capturedTime
            : getFilteredData(arr, "alertTriggered")[0].capturedTime;
      let isAlarmAlert =
        getFilteredData(arr, "alarmTriggered").length &&
          getFilteredData(arr, "alertTriggered").length
          ? "alarm-alert"
          : getFilteredData(arr, "alarmTriggered").length
            ? "alarm"
            : "alert";
      let minBucket = bucket.min;
      let maxBucket = bucket.max;

      groupedAlarmBucket.push({
        avgCapturedTime,
        isAlarmAlert,
        batchCount,
        minBucket,
        maxBucket
      });
    }
  });
  bucketExtremePoints = groupedAlarmBucket;
  return groupedAlarmBucket;
};

export const plotlineObj = (dataObj, index) => {
  //   const alarmImg = require('../images/webicons/alarm-red.svg');
  //   const alertImg = require('../images/webicons/alert-red.svg');

  let alarmBaseImg = `data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjBweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMjAgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ3LjEgKDQ1NDIyKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5hbGFybS1yZWQ8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iRkMtV2ViLUljb25zIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iSWNvbnMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC03MzYuMDAwMDAwLCAtNDAxLjAwMDAwMCkiPgogICAgICAgICAgICA8ZyBpZD0iTGFiZWxzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMDAuMDAwMDAwLCAxMDAuMDAwMDAwKSI+PC9nPgogICAgICAgIDwvZz4KICAgICAgICA8ZyBpZD0iYWxhcm0tcmVkIj4KICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTAsMTYuNjY2NjY2NyBDMTAuNzMzMzMzMywxNi42NjY2NjY3IDExLjMzMzMzMzMsMTYuMDY2NjY2NyAxMS4zMzMzMzMzLDE1LjMzMzMzMzMgTDguNjY2NjY2NjcsMTUuMzMzMzMzMyBDOC42NjY2NjY2NywxNi4wNjY2NjY3IDkuMjYsMTYuNjY2NjY2NyAxMCwxNi42NjY2NjY3IFogTTE0LDEyLjY2NjY2NjcgTDE0LDkuMzMzMzMzMzMgQzE0LDcuMjg2NjY2NjcgMTIuOTA2NjY2Nyw1LjU3MzMzMzMzIDExLDUuMTIgTDExLDQuNjY2NjY2NjcgQzExLDQuMTEzMzMzMzMgMTAuNTUzMzMzMywzLjY2NjY2NjY3IDEwLDMuNjY2NjY2NjcgQzkuNDQ2NjY2NjcsMy42NjY2NjY2NyA5LDQuMTEzMzMzMzMgOSw0LjY2NjY2NjY3IEw5LDUuMTIgQzcuMDg2NjY2NjcsNS41NzMzMzMzMyA2LDcuMjggNiw5LjMzMzMzMzMzIEw2LDEyLjY2NjY2NjcgTDQuNjY2NjY2NjcsMTQgTDQuNjY2NjY2NjcsMTQuNjY2NjY2NyBMMTUuMzMzMzMzMywxNC42NjY2NjY3IEwxNS4zMzMzMzMzLDE0IEwxNCwxMi42NjY2NjY3IFoiIGlkPSJTaGFwZSIgZmlsbD0iI0U0NEY0RiIgZmlsbC1ydWxlPSJub256ZXJvIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8cmVjdCBmaWxsLW9wYWNpdHk9IjAiIGZpbGw9IiMwMDAwMDAiIHg9IjAiIHk9IjAiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCI+PC9yZWN0PgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=
  `;

  let alertBaseImg = `data:image/svg+xml;base64,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
  `;
  let alarm = "alarmIcon";
  let alert = "alertIcon";
  // const batchDiv = '';
  const batchSize =
    dataObj.batchCount.toString().length > 2
      ? dataObj.batchCount.toString().length * 8
      : 20;
  const batchSizeBottom =
    dataObj.batchCount.toString().length > 2
      ? dataObj.batchCount.toString().length > 3
        ? dataObj.batchCount.toString().length > 4
          ? -1 * ((dataObj.batchCount.toString().length - 4) * 2 * 4)
          : 4
        : 0
      : 2;
  const batchPosition = dataObj.isAlarmAlert === "alarm-alert" ? 35 : 20;
  const batchDiv =
    `<div index = ` +
    index +
    ` class = batchCircle style="border:1px solid #e63900;
                        height:` +
    batchSize +
    `px; 
                        width:` +
    batchSize +
    `px;
                        background-color:#e63900;
                    -webkit-border-radius: 40px;
                    -moz-border-radius: 40px;
                    border-radius: 40px;
                    position: absolute;
                    cursor: pointer;
                    transform: rotate(-90deg);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    left:` +
    batchPosition +
    `px;
                    bottom:` +
    batchSizeBottom +
    `px;" >
                      <div class = batchCount index = ` +
    index +
    ` style="font-size:10px;
                        text-align: center;
                        line-height: 18px;
                        padding: 2px;
                        color:white;">` +
    dataObj.batchCount +
    `</div>
                     </div>`;
  let text =
    dataObj.isAlarmAlert === "alarm-alert"
      ? `<img class = ` +
      alarm +
      ` src=` +
      alarmBaseImg +
      ` style="transform: rotate(-90deg);"/><img class = ` +
      alert +
      ` src=` +
      alertBaseImg +
      ` style="transform: rotate(-90deg);position:relative;left:-7px"/>`
      : dataObj.isAlarmAlert === "alarm"
        ? `<img class = ` +
        alarm +
        ` src=` +
        alarmBaseImg +
        ` capturedTime = ` +
        dataObj.value +
        ` style="transform: rotate(-90deg);"/>`
        : `<img class = ` +
        alert +
        ` src=` +
        alertBaseImg +
        ` style="transform: rotate(-90deg);"/>`;

  //   ?`<img src={require("../images/webicons/alarm-red.svg")} />
  //   <img src={require("../images/webicons/alert-red.svg")} />`
  // :'<img src={require("../images/webicons/alert-red.svg")} />';

  text =
    dataObj.isAlarmAlert === "alert" ||
      (dataObj.isAlarmAlert === "alarm" && dataObj.batchCount <= 1)
      ? text
      : text + batchDiv;

  const labelObj = {
    align: "center",
    verticalAlign: "bottom",
    textAlign: "center",
    x: -2.5,
    y: 5,
    useHTML: true
  };
  const label = { ...labelObj, text };
  const plotlineObj = {
    id: "xPlotLine",
    color: "#FF0000",
    width: 1,
    zIndex: 8,
    label: label
  };

  const events = {
    click: function () {
      let self = this;
      var xPosition =
        self.axis.chart.xAxis[0].toPixels(self.options.value).toFixed(2) - 63;

      const text = "<div>this is a test</div>";

      if (!self.axis.chart.lbl) {
        self.axis.chart.lbl = self.axis.chart.renderer
          .label(text, xPosition, -45, null, null, null, true)
          .css({
            fontSize: "22pt",
            textAlign: "center",
            position: "absolute",
            zIndex: "999"
          })
          .add();
      } else {
        self.axis.chart.lbl.attr({
          text: text,
          x: xPosition
        });
      }
    },
    mouseout: function () {
      console.log("mouseout");
    }
  };

  const value = dataObj.value;
  const capturedTime = dataObj.capturedTime;
  const plotLine =
    dataObj.isAlarmAlert === "alert" ||
      (dataObj.isAlarmAlert === "alarm" && dataObj.batchCount <= 1)
      ? { ...plotlineObj, value, capturedTime, events }
      : { ...plotlineObj, value, capturedTime };
  return plotLine;
};

export const plotlinesChartArrayFunc = (groupedBucketData, getExtremeData) => {
  const dataObjArray = groupedBucketData.map(
    ({ avgCapturedTime, isAlarmAlert, batchCount }) => ({
      value: avgCapturedTime,
      isAlarmAlert,
      batchCount
    })
  );
  let plotlineArray = [];
  dataObjArray.forEach((dataObj, index) => {
    plotlineArray.push(plotlineObj(dataObj, index));
  });
  return plotlineArray;
};

export const plotlineFilteredArrayFunc = (
  notificationData = [],
  chartSize,
  alarmSize
) => {
  let getExtreme = getExtremeData(notificationData, "capturedTime");
  let notificationCount = notificationCountFunc(chartSize, alarmSize);
  let buckets = bucketsFunc(getExtreme.min, getExtreme.max, notificationCount);
  let groupedBucketData = groupedBucketDataFunc(notificationData, buckets);
  let plotlinesChartArray = plotlinesChartArrayFunc(
    groupedBucketData,
    getExtremeData
  );
  return plotlinesChartArray;
};

export const plotlineArrayFunc = (dataPoints, chartSize, alarmSize) => {
  let alarmData = [];
  let alertData = [];
  if (dataPoints && dataPoints.length) {
    if (dataPoints[0] != undefined) {
      alarmData = getAlarms(dataPoints);
      alertData = getAlerts(dataPoints);
    }
  }
  let notificationData = [...alarmData, ...alertData];
  let plotlineFilteredArray =
    notificationData && notificationData.length
      ? plotlineFilteredArrayFunc(notificationData, chartSize, alarmSize)
      : [];
  return plotlineFilteredArray;
};

export const getScrollMenuObj = assetId => {
  return {
    leftScrollMenu: "left-scroll-menu prev-" + assetId,
    rightScrollMenu: "right-scroll-menu next-" + assetId
  };
};

export const getTickPosition = (
  data,
  step,
  shiftTimeObject,
  zoomRangeTime,
  params,
  isCurrentZoom
) => {
  let obj = {
    min: null,
    max: null,
    tickPositions: null,
    graphZoomRangeTime: null
  };
  if (data && data.length) {
    /*Multigraph*/
    // let minArr = [],
    //   maxArr = [];

    /*To DO This changes was commented to use for 3540 Graph*/
    // data.map((item, index) => {
    //   minArr.push(getMin(getPluckedData(item.values, "capturedTime")));
    //   maxArr.push(getMax(getPluckedData(item.values, "capturedTime")));
    // });
    if (!isEmptyObj(shiftTimeObject) && !isCurrentZoom) {
      obj.max = shiftTimeObject.to;
      obj.min = shiftTimeObject.from;
    } else if (zoomRangeTime && !isEmptyObj(zoomRangeTime)) {
      /*To DO This changes was commented to use for 3540 Graph*/
      // obj.min = getMin(getPluckedData(data, "capturedTime"));
      // obj.max = getMax(getPluckedData(data, "capturedTime"));
      // obj.min = getMin(minArr);
      // obj.max = getMax(maxArr);
      obj.min = zoomRangeTime.from;
      obj.max = zoomRangeTime.to;
    } else {
      obj.min = params.from;
      obj.max = params.to;
    }
    obj.tickPositions = getMinMaxRange(obj.min, obj.max, step);
    if (obj.tickPositions.length > 1) {
      obj.graphZoomRangeTime = {
        from: obj.tickPositions[0],
        to: obj.tickPositions[obj.tickPositions.length - 1]
      };
    } else {
      obj.graphZoomRangeTime = {
        from: obj.min,
        to: obj.max
      };
    }
  } else {
    if (isCurrentZoom && !isEmptyObj(zoomRangeTime)) {
      obj.min = zoomRangeTime.from;
      obj.max = zoomRangeTime.to;
    } else if (!isEmptyObj(shiftTimeObject)) {
      obj.min = shiftTimeObject.from;
      obj.max = shiftTimeObject.to;
    } else {
      obj.min = params.from;
      obj.max = params.to;
    }
    obj.tickPositions = getMinMaxRange(obj.min, obj.max, step);
    obj.graphZoomRangeTime = {
      from: obj.tickPositions[0],
      to: obj.tickPositions[obj.tickPositions.length - 1]
    };
  }
  return obj;
};

export let isZoom = false;
export let onZoom = "onZoom";
export let onSlide = "onSlide";
export let minSwipeRange = 10000;
export let pinchRangeConst = 30;
export let leftSlider = "leftSlider";
export let rightSlider = "rightSlider";
export let zero = 0;
export let minZoom = 7000;
export const getClickEvent = () => {
  let user_agent = navigator.userAgent.toLowerCase(); // detect the user agent
  let clickEvent =
    user_agent.match(/iPhone|iPad|iPod/i) || user_agent.match(/Android/i)
      ? "touchstart"
      : "click"; //check native devices
  return clickEvent;
};
